import {Component} from 'react'
import {bindActionCreators} from 'redux'
import connect from 'react-redux/es/connect/connect'

import PageLayout from '../../Layout/PageLayout.jsx'

import actions from '../actions.js'

class AccessDenied extends Component {
  back = () => {
    if (this.props.route.redirect) {
      this.props.history.goBack()
    }
    this.props.history.goBack()
  }

  render() {
    return (
      <PageLayout>
        <h2 className="text-center">
          Erreur 401 - Vous n'avez pas accès à ce contenu.
        </h2>
        <p className="text-center">
          <button className="btn btn-primary" onClick={this.back}>Retour</button>
        </p>
      </PageLayout>
    )
  }
}

export default connect(
  (state) => ({}),
  (dispatch) => bindActionCreators({...actions}, dispatch)
)(AccessDenied)